// Work Orders › ⋯ › Export bottom paint list / Export outdrive service list: one CSV download each.
// Split out of app.js (docs/split-plan.md, session 1). Needs nothing from app.js.
// Both read this device's copies of /data and /customers (kept current by the change index), not
// the whole roots: the Realtime Database bills for downloads (docs/change-index.md).
import { idbCursorAll } from './utilities';

// A device copy as { id: record }, the shape the roots had.
async function deviceRoot(store) {
  const out = {};
  for (const rec of await idbCursorAll(store)) if (rec && rec.id) out[rec.id] = rec;
  return out;
}

document.getElementById('bottom-paint-export').addEventListener('click', async (e) => {
  e.preventDefault();
  e.stopPropagation();

  const result = exportBottomPaintCSV({
    data: await deviceRoot('jobData'),
    customers: await deviceRoot('customerData'),
    filename: "bottom_paint_export.csv"
  });

  console.log("Bottom paint export:", result);
});

function exportBottomPaintCSV({ data, customers, filename = "bottom_paint_export.csv" }) {
  const unwrap = (v) => (v && typeof v.val === "function" ? v.val() : v);

  const dataObj = unwrap(data);
  const custObj = unwrap(customers);

  if (!dataObj || typeof dataObj !== "object") throw new Error("exportBottomPaintCSV: data must be an object");
  if (!custObj || typeof custObj !== "object") throw new Error("exportBottomPaintCSV: customers must be an object");

  const csvEscape = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const isBottomPaint = (job) => {
    const candidates = [
      job?.Description,
      job?.description,
      job?.Short_Description_DM,
      job?.Short_Description,
      job?.Op_Type,
      job?.OpType
    ].filter((x) => typeof x === "string");

    return candidates.some((s) => /bottom\s*paint/i.test(s));
  };

  const rows = [];
  let scanned = 0;
  let skippedMeta = 0;

  for (const [jobId, job] of Object.entries(dataObj)) {
    if (jobId === "lastUpdated") {
      skippedMeta++;
      continue;
    }
    if (!job || typeof job !== "object") continue;

    scanned++;

    if (!isBottomPaint(job)) continue;

    const customerId = job?.Customer_ID ?? job?.customerId ?? "";
    const boatId = job?.Boat_ID ?? job?.boatId ?? "";

    const customer = custObj?.[customerId] ?? null;
    const boat = customer?.Boats?.[boatId] ?? null;

    const boatBottomType =
      boat?.Bottom_Paint_Type ??
      boat?.boatData?.Bottom_Paint_Type ??
      "";

    const boatBottomColor =
      boat?.Bottom_Paint_Color ??
      boat?.boatData?.Bottom_Paint_Color ??
      "";

    rows.push({
      Job_ID: job?.Job_ID ?? jobId,
      Work_Order: job?.Work_Order ?? "",
      Customer_ID: customerId,
      Boat_ID: boatId,
      Customer_Name: job?.Customer_Name ?? (customer ? `${customer?.Last_Name ?? ""}, ${customer?.First_Name ?? ""}`.replace(/^,\s*/, "").trim() : ""),
      Boat_Name: job?.Boat_Name ?? boat?.Boat_Name ?? boat?.boatData?.Boat_Name ?? "",
      Category: job?.Category ?? "",
      Op_Type: job?.Op_Type ?? "",
      OpCode: job?.OpCode ?? "",
      Status: job?.Status ?? "",
      Start_Date: job?.Start_Date ?? "",
      Haul_Date: job?.Haul_Date ?? "",
      Launch_Date: job?.Launch_Date ?? "",
      Bottom_Paint_Product: boat?.Bottom_Paint_Product ?? boat?.boatData?.Bottom_Paint_Product ?? "",
      Bottom_Paint_Type: boatBottomType,
      Bottom_Paint_Color: boatBottomColor,
      Description: job?.Description ?? job?.Short_Description_DM ?? job?.Op_Type ?? ""
    });
  }

  console.log("Bottom paint export scan:", { scanned, skippedMeta, matched: rows.length });

  const headers = [
    "Job_ID","Work_Order","Customer_ID","Boat_ID","Customer_Name","Boat_Name",
    "Category","Op_Type","OpCode","Status","Start_Date","Haul_Date","Launch_Date",
    "Bottom_Paint_Product","Bottom_Paint_Type","Bottom_Paint_Color","Description"
  ];

  const csv = headers.join(",") + "\n" + rows.map(r => headers.map(h => csvEscape(r[h])).join(",")).join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);

  return { count: rows.length, csv };
}


function exportServiceOutdrive2025CSV({ data, filename = "service_outdrive_2025.csv" }) {
  const unwrap = (v) => (v && typeof v.val === "function" ? v.val() : v);
  const dataObj = unwrap(data);

  if (!dataObj || typeof dataObj !== "object") throw new Error("exportServiceOutdrive2025CSV: data must be an object");

  const csvEscape = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const includesServiceOutdrive = (s) =>
    typeof s === "string" && s.toLowerCase().includes("service outdrive");

  const isStartDate2025 = (startDate) => {
    if (startDate == null) return false;
    const s = String(startDate).trim();
    if (!s) return false;
    return s.slice(0, 4) === "2025";
  };

  const rows = [];

  for (const [jobId, job] of Object.entries(dataObj)) {
    if (jobId === "lastUpdated") continue;
    if (!job || typeof job !== "object") continue;

    const desc = job?.Description ?? "";
    if (!includesServiceOutdrive(desc)) continue;

    const startDate = job?.Start_Date ?? "";
    if (!isStartDate2025(startDate)) continue;

    rows.push({
      Customer_Name: job?.Customer_Name ?? "",
      Boat_Name: job?.Boat_Name ?? "",
      Work_Order: job?.Work_Order ?? "",
      Start_Date: startDate
    });
  }

  const headers = ["Customer_Name", "Boat_Name", "Work_Order", "Start_Date"];
  const csv = headers.join(",") + "\n" + rows.map(r => headers.map(h => csvEscape(r[h])).join(",")).join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);

  return { count: rows.length, csv };
}

document.getElementById("service-outdrive-export").addEventListener("click", async (e) => {
  e.preventDefault();
  e.stopPropagation();

  try {
    const result = exportServiceOutdrive2025CSV({
      data: await deviceRoot('jobData'),
      filename: "service_outdrive_2025.csv"
    });

    console.log("Service Outdrive 2025 export complete:", result);
  } catch (err) {
    console.error("Service Outdrive export failed:", err);
  }
});
